import { Modal } from "antd";
import { DownloadOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import "../utils/manage.css";
import html2pdf from "html2pdf.js";
const DetailManage = ({ isOpen, toggle, selectedBusiness }) => {
  if (!selectedBusiness) return null;

  const {
    id,
    status,
    createdAt,
    paymentMethodName,
    clientNumber,
    prefixPhone,
    amount,
    realAmount,
    currency,
    merchantAccountName,
    developerAccountName,
    description,
    transactionReference,
  } = selectedBusiness;

  const formatDate = (timestamp) => dayjs(Number(timestamp)).format("DD-MM-YYYY");
const handleDownloadReceipt = () => {
  const element = document.getElementById("receipt-content");

  if (!element) return;

  html2pdf()
    .set({
      margin: 10,
      filename: `recu-${selectedBusiness?.transactionReference}.pdf`,
      html2canvas: { scale: 2 },
      jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
    })
    .from(element)
    .save();
};
  return (
    <Modal
      open={isOpen}
      onCancel={toggle}
      footer={null}
      centered
      width={500}
      className="modal-detail-payment"
    >
      <h2 className="modal-title">Information de la transaction</h2>

      <div className="payment-details">
        <div className="payment-row">
          <span className="label">Bénéficiare</span>
          <span className="value">{merchantAccountName}</span>
        </div>

        <div className="payment-row">
          <span className="label">Business</span>
          <span className="value">{developerAccountName}</span>
        </div>

        <div className="payment-row">
          <span className="label">Téléphone</span>
          <span className="value">{prefixPhone} {clientNumber}</span>
        </div>

        <div className="payment-row">
          <span className="label">Date de paiement</span>
          <span className="value">{formatDate(createdAt)}</span>
        </div>

        <div className="payment-row">
          <span className="label">Montant débité</span>
          <span className="value">{amount?.toLocaleString()} {currency}</span>
        </div>
      <div className="payment-row">
          <span className="label">Montant reçu </span>
          <span className="value">{realAmount?.toLocaleString()} {currency}</span>
        </div>
        <div className="payment-row">
          <span className="label">Moyen de paiement</span>
          <span className="value">{paymentMethodName}</span>
        </div>

        {status && (
          <div className="payment-row">
            <span className="label">Status</span>
            <span
              className="value"
              style={{
                color:
                  status === "SUCCESS"
                    ? "#28a745"
                    : status === "PENDING"
                    ? "#f0ad4e"
                    : "#dc3545",
                fontWeight: 500,
                fontFamily:'Poppins',
                fontSize:'13px'
              }}
            >
              {status === "SUCCESS"
                ? "Réussie"
                : status === "PENDING"
                ? "En attente"
                : "Échec"}
            </span>
          </div>
          )}
        {transactionReference && (
          <div className="payment-row">
            <span className="label">Reference</span>
            <span className="value">{transactionReference}</span>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default DetailManage;
